import { Pcategory } from './pcategory';
import { Utils } from '../helpers/utils';
import { environment } from '../../../environments/environment';

export class ProductTranslation {
  id: number;
  lang: 'en'|'pt'|'de'|'jp'|'cn'|'es'|'fr'|'ru'|'it';
  product_id: number;
  name: string;
  description: string;
}
export class Product {
  id: number;
  local_id: number;

  // changeable values
  name: string;
  description: string;
  price: string;
  delivery_plus: string;
  is_alcoholic: boolean;
  pcategory_id: number;
  print_location_id: number;
  picture_path: {url: string};

  product_translations: ProductTranslation[];

  n_people: number; // not yet implemented in backend

  hidden: boolean;
  delivery: boolean;
  delivery_name: string;
  additional_info: string;

  // timestamps
  created_at: string;
  updated_at: string;

  // set by our front-end app
  price_n: number;
  delivery_plus_n: number;
  showFullDescription: boolean;
  translatedName: string;
  translatedDescription: string;
  final_picture_path: string;
  final_mini_picture_path: string;
  parsedAdditionalInfo: any;
  prettyPrice: string;

  // given by our back-end app
  aws_picture_path: string;
  aws_mini_picture_path: string;

  static setAdditionalData(product: Product, mode: 'delivery'|'on_site' = 'delivery'): Product {
    product.price_n = Number(product.price);
    if(mode == 'on_site') // No delivery_plus for on_site consumption
      product.delivery_plus = null;

    product.delivery_plus_n = Number(product.delivery_plus || 0);
    product.price = (product.price_n + product.delivery_plus_n).toFixed(2);
    product.delivery_plus_n = 0;
    product.delivery_plus = null;

    product.translatedName = product.delivery_name || product.name;
    product.translatedDescription = product.description;
    try {
      product.parsedAdditionalInfo = JSON.parse(product.additional_info || '{}');
    } catch (e) {
      product.parsedAdditionalInfo = {};
    }

    // set final picture path
    if(product.aws_picture_path) {
      product.final_picture_path = product.aws_picture_path;
    } else {
      if(product.picture_path && product.picture_path.url) {
        product.final_picture_path = environment.server_url + product.picture_path.url;
      } else {
        product.final_picture_path = environment.server_url + "/default.png";
      }
    }
    // set final mini picture path
    if(product.aws_mini_picture_path) {
      product.final_mini_picture_path = product.aws_mini_picture_path;
    } else {
      if(product.picture_path && product.picture_path.url) {
        let paths = product.picture_path.url.split("/");
        let filename = paths[paths.length - 1];
        paths[paths.length - 1] = "mini_" + filename;
        product.final_mini_picture_path = environment.server_url + paths.join("/");
      } else {
        product.final_mini_picture_path = environment.server_url + "/default.png";
      }
    }

    return product;
  }
  static setArrayAdditionalData(products: Product[], mode: 'delivery'|'on_site' = 'delivery') {
    if(!products)
      return;
    for(let prod of products) {
      Product.setAdditionalData(prod, mode);
    }
  }
  static availableLangs(products: Product[]): string[] {
    let res = [];
    for(let product of products) {
      if(product.product_translations && product.product_translations.length > 0) {
        for(let translation of product.product_translations) {
          Utils.pushIfNotExists(res, translation.lang);
        }
      }
    }

    return res;
  }
  // 'lang' is the language abreviation, like 'pt', 'en', 'es', ...
  static translate(products: Product[], lang: string) {
    if(products == null)
      return;
    
    for(let product of products) {
      if(lang == null) {
        product.translatedName = product.delivery_name || product.name;
        product.translatedDescription = product.description;
      } else {
        for(let translation of product.product_translations) {
          if(lang == translation.lang) {
            product.translatedName = translation.name;
            product.translatedDescription = translation.description;
          }
        }
      }
    }
  }
}